import {Transform} from "@/lib/helper";
import BubbleService, {BubbleConstainsItem} from "../BubbleService";
import {FormData} from "@/lib/types/finsey/form"
import lodash from 'lodash'
import {Application, ApplicationSchedule} from "@/lib/types/finsey/application";
import {FinseyScoreService} from "@/services";

class ApplicationService extends BubbleService {
    constructor() {
        super();
    }

    createApplication = async (formData: any, amountData: { totalPayPerMonth: any; total: any; baseTotal: any; serviceFee: any; interestTotal: any; payStartDate: any; }, scheduleData: any, psychometricData: any, ekyc: any) => {
        try {
            amountData = {
                totalPayPerMonth: amountData.totalPayPerMonth,
                total: amountData.total,
                baseTotal: amountData.baseTotal,
                serviceFee: amountData.serviceFee,
                interestTotal: amountData.interestTotal,
                payStartDate: amountData.payStartDate
            }
            const application: any = await this.postApplication(formData, ekyc, amountData)
            console.log(application)
            if(psychometricData){
                const psychometric = await this.postPsychometric(psychometricData, application.application)
            }
            const schedule = await this.postScheduleLoan(amountData, scheduleData, application.application)
        } catch (error) {
            throw error
        }
    };

    postScheduleLoan = async (amountData: { totalPayPerMonth: any; serviceFee: number; }, scheduleData: any[], applicationId: string) => {
        try {
            let currentMonth = 0
            let processedScheduleData = scheduleData.map((item: { outstanding_principle: any; principle_paid: any; interest_rate_paid: any; }, index: number) => {
                let date = new Date();
                date.setDate(date.getDate() + 7)
                date.setMonth(date.getMonth() + currentMonth)
                let data = {
                    application: applicationId,
                    code: applicationId + '_' + (index + 1),
                    Outstanding_amount: item.outstanding_principle,
                    Principle_amount: item.principle_paid,
                    Interest_amount: item.interest_rate_paid,
                    Scheduled_payment_date: date,
                    Payment_amount: amountData.totalPayPerMonth,
                    Service_amount: amountData.serviceFee / scheduleData.length
                }
                currentMonth++;
                return JSON.stringify(data)
            }).join('\n')
            this.contentType = "text/plain"
            const result = await this.postObj('Scheduled_Loan_Payment/bulk', processedScheduleData)
        } catch (error) {
            throw error
        }
    }

    postPsychometric = async (psychometricData: any[], applicationId: any) => {
        try {
            const newlineSeparatedJSON = psychometricData
                .map((item: { answer: any; facet: any; question: any; index: any; }) => JSON.stringify({
                    application: applicationId,
                    answer: item.answer,
                    facet: item.facet,
                    question: item.question,
                    question_index: item.index
                }))
                .join("\n");
            this.contentType = "text/plain"
            const result = await this.postObj("Questionnaire_Result/bulk", newlineSeparatedJSON);
            return result
        } catch (error) {
            throw error
        }
    }

    postApplication = async (formData: FormData | any, ekyc: any, amountData: { totalPayPerMonth: any; interestTotal: any; serviceFee: any; }) => {
        try {
            const transform = new Transform()
            let contract_code = this.prepareContractCode(
                formData.phoneNumber,
                formData.cccd
            );

            let scoreData = formData.scoreData
            let blackList = formData.blackList ? 'hit' : 'miss'
            let warmList = formData.warmList ? 'hit' : 'miss'
            let repeat = formData.repeat ? 'true' : 'false'

            let data: any = {
                syncId: formData.syncId,
                contract_code: contract_code,

                name: formData.name,
                school: formData.school,
                student_id: formData.student_id,
                semester: formData.semester,
                principle_amount: transform.transformMoneyToNumber(formData.amount.toString()),
                id_code: formData.cccd,
                phone_number: formData.phoneNumber,
                email: formData.email,
                additional_email: formData.additionalEmail,
                payment_term: formData.month,

                student_account: formData.studentAccount,
                student_password: formData.studentPassword,

                cosigner_phone: formData.cosignerPhoneNumber,
                cosigner_name: formData.cosignerName,
                cosigner_relationship: formData.cosignerRelationship,

                monthly_amount: amountData.totalPayPerMonth,
                interest_amount: amountData.interestTotal,
                service_fee: amountData.serviceFee,

                isBadDebt: formData.isBadDebt,
                referral: formData.referral,
                coupon: formData.coupon,

                finseyScore: scoreData.finseyScore || 0,
                creditScore: scoreData.creditScore || 0,

                blackList,
                warmList,
                repeat
            };


            if(formData.gpaFile){
                data.gpaFile = await transform.prepareDataForBubbleImageUpload(formData.gpaFile)
            }

            if(formData.studentFile){
                data.studentFile = await transform.prepareDataForBubbleImageUpload(formData.studentFile)
            }


            const result = await this.postWf("zalo_receive_form", data);
            return result
        } catch (error) {
            throw error
        }
    }

    prepareContractCode = (phoneNumber: any, idCard: any) => {
        let xx = this.getLastCharacterOfString(phoneNumber, 2);
        let zz = this.getLastCharacterOfString(idCard, 2);
        let yyyy = this.generateString(4);
        let result = xx + yyyy.trim() + zz;
        return result.toUpperCase();
    };

    getLastCharacterOfString = (string: string, length: number) => {
        console.log(string)
        let lastChars = string.substring(string.length - length);
        return lastChars;
    };

    generateString(length: number) {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let result = " ";
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    getApplicationStatus = async (applicationId: string) => {
        let constraint: any = ''
        constraint = [{ key: 'Application ID', constraint_type: 'equals', value: applicationId }]
        constraint = JSON.stringify(constraint)
        let queryString = `${constraint ? `&constraints=${constraint}` : ''}`
        const result: any = await this.getObj(`Application_Status?${queryString}`)
        return result.results
    }

    getApplicationByCode = async (contractCode:string) => {
        const data = await this.postWf('get_contract_by_code', { contract_code: contractCode });
        return data
    }

    getApplications = async (currentPage: string | number, pageSize: string | number, conditions?: BubbleConstainsItem[]) => {
        const data = await this.getListObj('Application',currentPage, pageSize, conditions);
        return data.results
    }

    getFullApplicationDetailById = async (id: string) => {
        const data = await this.postWf('get_full_application_detail', { id });
        return data
    }

    getApplicationByEmail = async (email: string) => {
        const data:any = await this.postWf('get_application_by_email', {email})
        // const isReApply = await this.isReApply(data.application)
        return {
            applications : data.application,
        }
    }

    isReApply = async (applications: Application[]) => {
        for(const application of applications) {
            const detail: any = await this.getFullApplicationDetailById(application._id)
            const schedules: ApplicationSchedule[] = detail.schedule
            let consecutiveCount = 0
            for(const schedule of schedules) {
                if(schedule.Late_days >= 7){
                    return false
                }
                if(schedule.Paid_status == 'Đã thanh toán đủ'){
                    consecutiveCount++
                }else{
                    consecutiveCount = 0
                }
                if(consecutiveCount >= 3){
                    return true
                }
            }
        }
        return false
    }
}

export default ApplicationService;
